import React from 'react';

/**
 * Hook for observing intersection changes.
 *
 * @param {React.RefObject} ref - The reference to the element to observe.
 * @param {IntersectionObserverInit} options - Options for the IntersectionObserver.
 * @returns {boolean} Whether the observed element is intersecting with the viewport.
 */
export default function useIntersectionObserver(ref, options) {
  const [isIntersecting, setIsIntersecting] = React.useState(false);

  const supported = typeof globalThis !== 'undefined' && 'IntersectionObserver' in globalThis;

  React.useEffect(() => {
    if (!supported) return; // Exit early if not supported (e.g., during SSR)

    const observer = new IntersectionObserver(([entry]) => {
      setIsIntersecting(entry.isIntersecting);
    }, options);

    if (ref?.current) {
      observer.observe(ref.current);
    }

    return () => {
      ref?.current && observer.unobserve(ref.current);
    };
  }, []);

  return isIntersecting;
}
